export const specialization = {
  acupuntura: 'Acupuntura',
  cardiologia: 'Cardiologia',
  comportamentoAnimal: 'Comportamento animal',
  dermatologia: 'Dermatologia',
  endocrinologia: 'Endocrinologia',
  fisioterapia: 'Fisioterapia',
  geral: 'Geral',
  hematologia: 'Hematologia',
  homeopatia: 'Homeopatia',
  nefrologia: 'Nefrologia',
  neurologia: 'Neurologia',
  nutrologia: 'Nutrologia',
  odontologia: 'Odontologia',
  oftalmologia: 'Oftalmologia',
  ortopedia: 'Ortopedia',
  pediatria: 'Pediatria',
};
